export default "__VITE_ASSET__nZA0WVpt__"